<template>
  <div id="app">
    <neon-header></neon-header>
    <main>
      <slot id="neon-main"></slot>
    </main>
    <neon-footer></neon-footer>
  </div>
</template>

<script>
  import Header from '../common/Header'
  import Footer from '../common/Footer'

  export default {
    name: 'app',
    components: {
      'neon-header': Header,
      'neon-footer': Footer
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/common/Main.vue